export default {
  get_all: { method: "get", url: "api/estados" },
  show: { method: "get", url: "api/estados{/id}" },
  store: { method: "post", url: "api/estados" },
  update: { method: "put", url: "api/estados{/id}" },
  delete: { method: "delete", url: "api/estados{/id}" },
};
